// TODO: Add more service types and their corresponding glyphs as needed
export const serviceTypeGlyphMap: Record<string, string> = {
  ai: '◫',
  'education-university': '◇',
  'gaming-entertainment': '▦',
  development: '◉',
  'design-content': '▣',
  business: '⌘',
  'gift-cards': '✦',
  'music-movies': '♫',
  'other-services': '＋',
}

export const getServiceTypeGlyph = (slug?: string | null): string => {
  return serviceTypeGlyphMap[slug ?? ''] ?? '✦'
}
